// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"24b2f420","242":"8f106a31","285":"994fa1e3","306":"73d5846c","724":"25c1e3d8","820":"0072759b"}[chunkId] + ".chunk.js";
};